import {Loader} from 'google-maps';

class Maps {
	constructor(config) {
		this.config = Object.assign({
			scope: ''
		}, config);

		this.$scope = $(this.config.scope);
	}

	async init() {
		let key = this.$scope.data('key');
		let google = await (new Loader(key, {})).load();

		let maps = new google.maps.Map(this.$scope[0], {
			center: {lat: 52.378280, lng: 5.771660},
			zoom: 8,
		});

		return {
			google: google,
			maps: maps
		};
	}
}

export default Maps;